import { render } from "./MFITTTermsButtons.vue?vue&type=template&id=c91af974"
import script from "./MFITTTermsButtons.vue?vue&type=script&lang=js"
export * from "./MFITTTermsButtons.vue?vue&type=script&lang=js"
script.render = render

export default script